module.exports = __webpack_public_path__ + "static/grafika9-0916ae6517392010e38338c428faecf9.png";